// extracted by mini-css-extract-plugin
export var container = "index-module--container--iDw5h";
export var gatsbyImage = "index-module--gatsbyImage--Nl3Zk";
export var wrapper = "index-module--wrapper--M5-Tx";